<template>
  <TemplatePopup
    :showMessage="false"
    :fullScreen="fullScreen"
    :geometry="entity.geometry"
    :saveDisabled="saveDisabled"
  >
    <div slot="header">Poste</div>
    <div slot="body">
      <b-tabs content-class="mt-3">
        <!-- ABA DADOS -->
        <b-tab title="Dados" active>
          <b-form-group label="Nome:">
            <b-form-input
              id="inputName"
              v-model="entity.name"
              maxlength="50"
              size="sm"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Identificação:">
            <b-form-input
              id="inputIdentification"
              v-model="entity.identification"
              maxlength="24"
              size="sm"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Endereço:">
            <b-form-input
              id="inputAddress"
              v-model="entity.address"
              size="sm"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Kit de ferragens:">
            <b-form-select id="inputKitList" v-model="entity.kitId" size="sm">
              <b-form-select-option
                v-for="entityList in kitList"
                :value="entityList.id"
                :key="entityList.id"
              >
                {{ entityList.name }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Pasta:">
            <b-form-select id="selectFolder" v-model="entity.folderId" size="sm">
              <b-form-select-option
                v-for="entityList in folderList"
                :value="entityList.id"
                :key="entityList.id"
              >
                {{ entityList.name }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-tab>

        <b-tab title="Características Técnicas">
          <b-form-group label="Material:">
            <b-form-select id="inputMaterial" v-model="entity.material" size="sm">
              <b-form-select-option value="Concreto">Concreto</b-form-select-option>
              <b-form-select-option value="Madeira">Madeira</b-form-select-option>
              <b-form-select-option value="Metálico">Metálico</b-form-select-option>
              <b-form-select-option value="Fibra">Fibra</b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Altura (m):">
            <b-form-input
              id="inputHeight"
              v-model.number="entity.height"
              type="number"
              step="0.1"
              min="0"
              size="sm"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Peso aproximado (kg):">
            <b-form-input
              id="inputWeight"
              v-model.number="entity.weight"
              type="number"
              step="0.1"
              min="0"
              size="sm"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Tipo de tensão:">
            <b-form-select id="inputVoltageType" v-model="entity.voltageType" size="sm">
              <b-form-select-option value="Alta">Alta</b-form-select-option>
              <b-form-select-option value="Baixa">Baixa</b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Condição física:">
            <b-form-select id="inputPhysicalCondition" v-model="entity.physicalCondition" size="sm">
              <b-form-select-option value="Boa">Boa</b-form-select-option>
              <b-form-select-option value="Regular">Regular</b-form-select-option>
              <b-form-select-option value="Ruim">Ruim</b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group>
            <b-form-checkbox
              id="inputAuthorized"
              v-model="entity.authorized"
            >
              Poste autorizado
            </b-form-checkbox>
          </b-form-group>

          <b-form-group>
            <b-form-checkbox
              id="inputTransformer"
              v-model="entity.transformer"
            >
              Poste com transformador
            </b-form-checkbox>
          </b-form-group>

          <b-form-group label="Outros cabos Telecom:">
            <b-form-select id="inputOtherTelecomCables" v-model="entity.otherTelecomCables" size="sm">
              <b-form-select-option value="true">Sim</b-form-select-option>
              <b-form-select-option value="false">Não</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-tab>
      </b-tabs>
    </div>

    <div slot="button">
      <div class="text-center">
        <b-button-group>
          <b-button
            id="btnComments"
            @click.prevent="comment()"
            v-has-permission.permission="['COM', 'VI']"
            variant="muted"
          >
            <i class="fa fa-comments fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Comentários</p>
          </b-button>

          <b-button
            id="btnImage"
            @click.prevent="image()"
            v-has-permission.permission="['IMG', 'VI']"
            variant="muted"
          >
            <i class="fa fa-image fa-lg"></i>
            <p class="button-text mb-0">Imagem</p>
          </b-button>

          <b-button
            id="btnDelete"
            @click.prevent="remove()"
            v-has-permission.permission="['POS', 'EX']"
            variant="muted"
            :disabled="isNew"
          >
            <i class="fa fa-times-circle fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Excluir</p>
          </b-button>

          <b-button
            id="btnSave"
            @click.prevent="save()"
            :disabled="saveDisabled"
            v-has-permission.permission="['POS', 'AL', 'CA']"
            variant="muted"
          >
            <i class="fa fa-floppy-o fa-lg"></i>
            <p class="button-text mb-0">Salvar</p>
          </b-button>
        </b-button-group>
      </div>
    </div>
  </TemplatePopup>
</template>

<script>
import TemplatePopup from "../../../template/TemplatePopup";
import {
  polePath,
  hardwareKitSimplePath,
  folderSimplePath,
} from "../../../router/ApiPaths";
import PopupBase from "./PopupBase";

export default {
  name: "PoleMap",
  extends: PopupBase,
  data() {
    return {
      kitList: [],
      folderList: [],
    };
  },
  components: {
    TemplatePopup,
  },
  beforeMount() {
    this.entity = {
      kitId: "",
      material: "",
      height: null,
      weight: null,
      voltageType: "",
      physicalCondition: "",
      authorized: false,
      transformer: false,
      otherTelecomCables: ""
    };
  },
  mounted: function () {
    let path = polePath(this.folderId);
    this.init(path, true);

    this.getAllDirect(hardwareKitSimplePath).then((data) => {
      this.kitList = data;
    });
    this.getAllDirect(folderSimplePath).then((data) => {
      this.folderList = data;
    });
  },
  computed: {
    missingName: function () {
      return !this.entity.name;
    },
    missingAddress: function () {
      return !this.entity.address;
    },
    missingFolder: function () {
      return !this.entity.folderId;
    },
    saveDisabled: function() {
      return !this.isDirty || this.missingName || this.missingAddress || this.missingFolder;
    }
  },
};
</script>
